import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { useSearchParams } from "react-router-dom"

import { ORDER_STATUSES, OrderStatus, statusColor } from "./orderStatus"

function StatusDot({ status }: { status: OrderStatus }) {
  return (
    <Box
      component="span"
      sx={(theme) => ({
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        bgcolor: theme.palette[statusColor[status]].main,
        mr: 1,
      })}
    />
  )
}

export function OrdersStatusFilter() {
  const [searchParams, setSearchParams] = useSearchParams()
  const status = searchParams.get('status') ?? ''

  function handleChange(event: SelectChangeEvent) {
    const value = event.target.value
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      if (value) {
        next.set('status', value)
      } else {
        next.delete('status')
      }
      next.delete('page')
      return next
    }, { replace: true })
  }

  return (
    <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
      <InputLabel id="orders-status-label">Situação</InputLabel>
      <Select
        labelId="orders-status-label"
        label="Situação"
        value={status}
        onChange={handleChange}
        renderValue={(value) => (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {value && <StatusDot status={value as OrderStatus} />}
            {value || 'Todas'}
          </Box>
        )}
      >
        <MenuItem value="">Todas</MenuItem>
        {ORDER_STATUSES.map((orderStatus) => (
          <MenuItem key={orderStatus} value={orderStatus}>
            <StatusDot status={orderStatus} />
            {orderStatus}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
